<template>
  <DescriptionListItemContainer
    :title="props.title"
    :full="props.full"
    :class="classes"
  >
    <DescriptionListItemDescription :description="props.description">
      <slot />
    </DescriptionListItemDescription>
  </DescriptionListItemContainer>
</template>

<script setup>
import { computed } from 'vue'
import DescriptionListItemContainer from './DescriptionListItemContainer.vue'
import DescriptionListItemDescription from './DescriptionListItemDescription.vue'

const props = defineProps({
  title: String,
  description: [String, Number],
  full: Boolean,
  center: Boolean,
})

const classes = computed(() => {
  if (props.center) return 'text-center'
})
</script>
